/* eslint-disable max-len */
import React from 'react';


const TemptedIcon = (props) => (
  <svg
    {...props}
    viewBox="0 0 260 260"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="130" cy="130" fill="#EE4337" r="130" />
    <path
      d="M142.3,101c4.5-2,8.3-3.4,12-5.2c7.2-3.6,14.3-7.1,22.6-7.1c8.9,0,17.1,5.4,20.2,13.7
		c-1.3-0.9-2.2-1.5-3.2-2.2c-5.3-3.9-11.2-5.6-17.8-5.5c-2.5,0-3.7,1-4.1,3.6c-3.3,19.3-6.7,38.6-10.1,58c-0.5,2.8-1,5.7-1.4,8.5
		c-0.3,2.2-1,3.4-3.6,3.1c-2.3-0.2-4.6,0-7.5,0c4.3-23.3,8.4-46.1,12.8-69.9c-11.8,5.3-23,9-35.2,2.7c4.9,0,9.3,0,13.9,0
		c-0.4-4.9-1.3-9.7-1-14.3c0.3-5.3,1.1-10.9,2.9-15.8c2.3-6.3,7.6-9.6,14.6-9.4c3.3,0.1,4.9,1.5,4.9,4.2c0,3.2-2,5.5-5,5.4
		c-1.3,0-2.8-0.3-3.8-0.9c-2.8-1.9-4.3-0.5-5.4,1.9c-3.5,7.2-4.6,15-5.4,22.8C142.5,96,142.5,97.9,142.3,101z" fill="#fff"
    />
    <path
      d="M130.9,95.6c-5.7,0-11.5-0.5-17.2,0.1c-7.4,0.9-15,2-22.1,4.1c-17.4,5.3-26.5,18-29.5,35.5
		c-3.8,21.7,0.1,42.1,10.4,61.4c3,5.5,6.1,11,9.7,17.3c-1.2-0.9-1.7-1.2-2.1-1.6C67,198.8,57.7,183,55,164
		c-2.7-18.9,0.8-36.7,11.1-52.9c4.6-7.2,11.2-11.9,19-14.9c12.2-4.8,33-5.5,45.8-1.7C130.9,94.9,130.9,95.2,130.9,95.6z" fill="#fff"
    />
    <path
      d="M90.4,78.5c-7.3-3.6-13.9-8.3-18.9-14.9c-7.1-9.2-7.2-24.7-0.4-34.1c0.5-0.7,1.1-1.3,1.5-1.7
		c12.1,7.1,24.3,13.8,36,21.2c7.2,4.6,13.9,9.9,20.3,15.6c3.3,2.9,5.9,7,7.8,11c1.5,3,1.4,6.7,2,10.1c-0.4,0.1-0.7,0.2-1.1,0.3
		c-0.2-0.3-0.4-0.6-0.5-0.9c-2.4-12.4-10.3-20.4-21.1-25.7c-7.9-3.9-16.2-7.2-24.2-11c-6.5-3-13.2-5.8-18.2-11.9
		c-4.4,7.6-5,15.2-1.6,23c2.9,6.7,8.1,11.3,13.9,15.3c1.6,1.1,3.3,2.2,5,3.3C90.7,78.2,90.6,78.3,90.4,78.5z" fill="#fff"
    />
    <path
      d="M147,222.9c5.8-0.4,12-0.2,17.8-1.4c10.4-2.1,18.4-8.4,25.2-16.3c5.8-6.8,10.1-14.5,13.6-22.7
		c0.5-1.2,1.1-2.4,2.2-3.5c-0.2,1-0.3,2-0.5,2.9c-2.4,10.8-6.1,21.1-12.4,30.3c-5.7,8.4-13.1,14.4-23.6,15.6
		C161.2,228.7,153.9,226.2,147,222.9z" fill="#fff"
    />
    <path d="M88.2,56.1c23,2.9,47.1,22.5,48.3,39.6C125.5,75.5,108,64.5,88.2,56.1z" fill="#fff" />
    <path d="M125.5,224.4c-4.6,10.6-19.7,9.6-28.4,1.6C106.9,231.5,116.3,231.4,125.5,224.4z" fill="#fff" />
    <path d="M90.8,78c11.3,5.7,23.3,9.5,35.5,12.7c-12.8-1.7-24.7-5.9-35.9-12.2C90.6,78.3,90.7,78.2,90.8,78z" fill="#fff" />
  </svg>
);

export default TemptedIcon;
